
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { DeviceNameAdvancedFilterRule } from "@/types/sv-data/system-view/advanced-filters/AdvancedStatusFilterRules";

@Component({})
export default class DeviceNameAdvancedFilter extends Vue {
	@Prop(Object) value: DeviceNameAdvancedFilterRule;

	public static readonly RuleIdentifier: string = "DeviceName";

	private ruleSettings: DeviceNameAdvancedFilterRule = {
		filterRuleType: DeviceNameAdvancedFilter.RuleIdentifier,
		deviceName: "",
		enabled: false
	};

	private async mounted(): Promise<void> {
		if(this.value !== null) {
			this.ruleSettings = this.value;
		}
	}

	@Watch("ruleSettings", { deep: true })
	private async ruleUpdated(): Promise<void> {
		this.$emit("input", this.ruleSettings);
	}
}
